"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("./InputField"));
const api_1 = require("../api");
const Button_1 = __importDefault(require("./Button"));
const errorNotification_1 = require("../errorNotification");
const axios_1 = __importDefault(require("axios"));
const quickOrderedFilter_1 = require("../components/quickOrderedFilter");
const utils_1 = require("../components/utils");
const MultiselectField_1 = __importDefault(require("./MultiselectField"));
const NewQualityForm = ({ handleNewQuality, ...props }) => {
    const [plants, setPlants] = (0, react_1.useState)([]);
    const qualityApi = new api_1.PlantOptionApi;
    const values = {
        plant_id: null,
        tb: '',
        ean: null,
    };
    (0, react_1.useEffect)(() => {
        const fetchPlants = async () => {
            const { data } = await axios_1.default.get('/api/searchitems');
            setPlants(data.items);
        };
        fetchPlants();
    }, []);
    const handleSearch = async (query, callback) => {
        const parts = query ? query.toString().toLowerCase().split(' ') : [];
        return callback(plants.filter((item) => {
            return (0, quickOrderedFilter_1.quickOrderedFilter)((item['botanisch_slugged'] || '').split("-"), parts);
        }));
    };
    const debouncedSearch = (0, utils_1.debounce)(handleSearch, 300);
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        try {
            const { success, record } = await qualityApi.create(values);
            if (success)
                handleNewQuality(record);
        }
        catch (error) {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
        }
        setSubmitting(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(formik_1.Formik, { initialValues: values, onSubmit: onSubmit },
            react_1.default.createElement(formik_1.Form, { className: "space-y-2" },
                react_1.default.createElement(MultiselectField_1.default, { cacheOptions: true, onBlurResetsInput: false, name: "plant_id", label: "Pflanze", loadOptions: debouncedSearch, menuPortalTarget: document.body, defaultOptions: plants.slice(0, 20), getOptionValue: (option) => option.id, getOptionLabel: (option) => option.botanisch }),
                react_1.default.createElement(InputField_1.default, { name: "tb", type: "text", label: "Tb" }),
                react_1.default.createElement("div", { className: "text-right" },
                    react_1.default.createElement(Button_1.default, { type: "submit" }, "Erstellen"))))));
};
exports.default = NewQualityForm;
